import { FileArray } from '@aperturerobotics/chonky';
import { useMemo } from 'react';
import { CustomFileMap, GALLERY_ROOT_ID } from './useGalleryFileMap';

export const useFiles = (
  fileMap: CustomFileMap,
  currentFolderId: string
): FileArray => {
  const getShortFileName = (fileName: string) => {
    if (!fileName) return '';
    const lastDotIndex = fileName.lastIndexOf('.');
    const type =
      lastDotIndex === -1
        ? ''
        : fileName.substring(lastDotIndex, fileName.length);
    const baseFileName =
      lastDotIndex === -1 ? fileName : fileName.substring(0, lastDotIndex);
    if (baseFileName.length <= 8) {
      return fileName;
    }
    return baseFileName.substring(0, 8) + '...' + type;
  };

  return useMemo(() => {
    const folderId = currentFolderId || GALLERY_ROOT_ID;
    const currentFolder = fileMap?.[folderId] ?? fileMap?.[GALLERY_ROOT_ID];
    const childrenIds = currentFolder?.childrenIds ?? [];
    return childrenIds
      .map((fileId: string) => fileMap[fileId])
      .filter(Boolean)
      .map((file) => ({
        ...file,
        name: getShortFileName(file.name),
      }));
  }, [currentFolderId, fileMap]);
};
